import { csx } from '@vtex/admin-ui'

const styles = {
  itemContainer: csx({ whiteSpace: 'pre' }),
  itemText: csx({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
}

export default styles
